import path from 'node:path';

export const toPosix = (p: string) =>
  path.sep === path.posix.sep ? p : p.split(path.sep).join(path.posix.sep);

export const getExtensionRelativePaths = ({
  cwd,
  projectFolder,
  extensionFileName,
  codeFileType,
}: {
  cwd: string;
  projectFolder: string;
  extensionFileName: string;
  codeFileType: 'tsx' | 'ts' | 'html';
}) => {
  const relativePathToExtensionDir = path.relative(
    path.join(projectFolder, 'src'),
    cwd
  );
  const relativePathToCodeFile = `./${toPosix(
    path.join(
      relativePathToExtensionDir,
      `${extensionFileName}.${codeFileType}`
    )
  )}`;
  const relativePathToConfigFile = `./${toPosix(
    path.join(relativePathToExtensionDir, `${extensionFileName}.extension.ts`)
  )}`;

  return {
    relativePathToExtensionDir,
    relativePathToCodeFile,
    relativePathToConfigFile,
  };
};
